// extracted by mini-css-extract-plugin
export default {"wrapperClass":"eZ3Dqgf0Kc71TO_jVP85"};